import { Component, Input } from '@angular/core'

import { PermissionSourceType } from '@core/types/permissions.source'
import { PermissionsService } from '@shared/services/permissions.service'

export interface NavLink {
  path: string
  label: string
  permission?: PermissionSourceType
  exact?: boolean
  order?: number
}

@Component({
  selector: 'lin-tab-nav-bar-upd',
  templateUrl: './tab-nav-bar-upd.component.html',
  styleUrls: ['./tab-nav-bar-upd.component.scss'],
  standalone: false,
})
export class TabNavBarUpdComponent {
  @Input() navLinks: NavLink[]

  constructor(private permissionsService: PermissionsService) {}

  hasPermission(permissionType: PermissionSourceType) {
    if (!permissionType) return true
    return this.permissionsService.hasPermissionSync(permissionType)
  }
}
